import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import styles from '../styles/Navbar.module.scss';
import msdLogo from '../assets/images/logos/msd-logo.svg';

const Navigation = () => {
  return (
    <Navbar collapseOnSelect expand='lg' bg='light' variant='light' id='home'>
      <Container fluid>
        <Navbar.Brand href='/' className='bold' style={{ fontSize: '22px' }}>
          Global Health Innovation Fund
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse
          className='justify-content-end'
          id='responsive-navbar-nav'
        >
          <Nav>
            <img
              className={styles.msdLogo}
              src={msdLogo}
              alt='MSD logo'
              target='_blank'
              width={'100px'}
            />
            <Nav.Link href='/#investment-focus' style={{ marginTop: '8px' }}>
              Investment Focus
            </Nav.Link>
            <Nav.Link href='/#portfolio' style={{ marginTop: '8px' }}>
              Portfolio
            </Nav.Link>
            <Nav.Link href='/#ghif-distinction' style={{ marginTop: '8px' }}>
              The GHIF Distinction
            </Nav.Link>
            <Nav.Link href='/#our-team' style={{ marginTop: '8px' }}>
              Our Team
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
